import { createRef } from 'react';

class ToastService {
    constructor() {
        this.toast = createRef();
    }

    setToast(toastRef) {
        this.toast = toastRef;
    }

    show(options) {
        if (this.toast.current) {
            this.toast.current.show(options);
        }
    }

    success(message, summary = 'Başarılı') {
        this.show({
            severity: 'success',
            summary: summary,
            detail: message,
            life: 5000,
        });
    }

    error(message, summary = 'Hata') {
        this.show({
            severity: 'error',
            summary: summary,
            detail: message,
            life: 5000,
        });
    }

    warn(message, summary = 'Uyarı') {
        this.show({
            severity: 'warn',
            summary: summary,
            detail: message,
            life: 5000,
        });
    }

    info(message, summary = 'Bilgi') {
        this.show({
            severity: 'info',
            summary: summary,
            detail: message,
            life: 5000,
        });
    }

    clear() {
        if (this.toast.current) {
            this.toast.current.clear();
        }
    }
}

const toastService = new ToastService();
export default toastService;